module.exports = __webpack_public_path__ + "img/videos-blue.fee53ba9.png";